import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import Form from "components/react-validation/components/form";
import { Panel, Tab, Row, Col } from "react-bootstrap";
import * as LotActionType from "../constants";
import { Dropdown } from "../../components/Dropdown/Dropdown";
import { v4 as uuidv4 } from "uuid";
import Moment from "moment";
import Datetime from "react-datetime";
import word from "../../assets/img/file_word.png";
import excel from "../../assets/img/file_excel.png";
import pdf from "../../assets/img/file_pdf.png";
import ppt from "../../assets/img/file_pp.png";
import video from "../../assets/img/file_video.png";
import other from "../../assets/img/file_other.png";
import { Link } from "react-router-dom";
import "../categoryModal.scss";
import heic2any from "heic2any";
import {
  convertTiffToJpeg,
  getTruncatedFilename,
} from "../../utils/ImageConvertor";

const GroupCategory = {
  videoFile: { id: 2, name: "Video" },
  profileImages: { id: 1, name: "Image" },
  registrationImages: { id: 3, name: "RegistrationManual" },
  userCareManualImages: { id: 4, name: "UserCareManual" },
  limitedWarrantyImages: { id: 5, name: "LimitedWarranty" },
  receiptsImages: { id: 6, name: "Receipts" },
  serviceContractOthersImages: { id: 7, name: "ServiceContracts" },
  serialImage: { id: 8, name: "SerialImage" },
};

export class InventoryEditItemModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    onDrop: PropTypes.func,
    accept: PropTypes.string,
    dispatch: PropTypes.func,
    lot: PropTypes.object,
    fetchInventoryCategoriesHo: PropTypes.func,
    isEdit: PropTypes.bool,
    itemDetails: PropTypes.object,
    homeownerLotSelectList: PropTypes.array,
    HomeownerInventoryCategory: PropTypes.array,
    getInventoryDetails: PropTypes.func,
    fetchInventoryCategories: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      isDragging: false,
      profileImages: [],
      uploading: false,
      uploadProgress: 0,
      selectedLotId: null,
      lotDetails: null,
      activeKey: "1",
      showDocumentInfo: true,
      lot: this.props.lot,
      editingState: {},
      registration: "",
      registrationImages: [],
      registrationImagesError: "",
      uploadResults: [],
      userCareManual: "",
      userCareManualImages: [],
      userCareManualImagesError: "",
      showBasicDetails: true,
      showItemDetail: false,
      showLinkDocument: false,
      showReceiptsotherDocs: false,
      limitedWarranty: "",
      limitedWarrantyImages: [],
      limitedWarrantyImagesError: "",
      expandedPanels: {},
      editCategoryIndex: null,
      name: "",
      itemCategory: null,
      property: null,
      smartApp: null,
      smartAppList: [],
      locationInHome: "",
      profileImagesError: "",
      deletedFiles: [],
      receiptsImages: [],
      receiptsImagesError: "",
      serviceContractOthersImages: [],
      serviceContractOthersImagesError: "",
      generalDescription: "",
      categoryListing: [],
      propertList: null,
      locationInHomeList: [
        { text: "Kitchen", value: "Kitchen" },
        { text: "Bedroom", value: "Bedroom" },
        { text: "Store Room", value: "Store Room" },
        { text: "Living Area", value: "Living Area" },
        { text: "Porch", value: "Porch" },
        { text: "Backyard", value: "Backyard" },
      ],
      typeOfPurchaseList: [
        { text: "Maintenance", value: "Maintenance" },
        { text: "Capital Management", value: "Capital Management" },
        { text: "Equipment", value: "Equipment" },
        { text: "Personal Belonging", value: "Personal Belonging" },
      ],
      typeOfPurchase: null,
      videoFile: null,
      videoPreviewUrl: "",
      videoError: "",
      warrantyError: "",
      hasPopulatedForm: false,
      error: "",
      showOtherDocs: false,
      otherImages: [],
      appName: "",
      androidURL: "",
      iosURL: "",
      appError: "",
      showAddApp: false,
      subdomain: "",
      serialImage: null,
      serialImagePreviewUrl: "",
      serialImageError: "",
    };

    // Bind methods for performance
    this.handleFileInputClick = this.handleFileInputClick.bind(this);
    this.handleRegistrationInputClick =
      this.handleRegistrationInputClick.bind(this);
    this.handleUserManualInputClick =
      this.handleUserManualInputClick.bind(this);
    this.handleLimitedWarrantyInputClick =
      this.handleLimitedWarrantyInputClick.bind(this);
    this.handleReceiptsInputClick = this.handleReceiptsInputClick.bind(this);
    this.handleServiceContractInputClick =
      this.handleServiceContractInputClick.bind(this);
    this.handleVideoInputClick = this.handleVideoInputClick.bind(this);
    this.handlePropertyChange = this.handlePropertyChange.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleTypeOfPurchaseChange =
      this.handleTypeOfPurchaseChange.bind(this);
    this.handleSmartAppChange = this.handleSmartAppChange.bind(this);
    this.handleGeneralDescriptionChange =
      this.handleGeneralDescriptionChange.bind(this);
    this.handleShowBasicDetailsToggle =
      this.handleShowBasicDetailsToggle.bind(this);
    this.handleShowItemDetailToggle =
      this.handleShowItemDetailToggle.bind(this);
    this.handleShowLinkDocumentToggle =
      this.handleShowLinkDocumentToggle.bind(this);
    this.handleShowReceiptsToggle = this.handleShowReceiptsToggle.bind(this);
    this.handleShowOtherDocsToggle = this.handleShowOtherDocsToggle.bind(this);
  }

  componentDidMount() {
    if (this.props.isOpen) {
      this.fetchProperty();
    }
  }

  componentDidUpdate(prevProps) {
    const modalJustOpened = !prevProps.isOpen && this.props.isOpen;

    if (modalJustOpened) {
      this.setState({ hasPopulatedForm: false }, () => {
        this.fetchProperty();
      });
    }

    // Optimize subdomain extraction with memoization
    if (
      !this.state.subdomain &&
      this.props.lot &&
      this.props.lot.extensionValue &&
      this.props.lot.extensionValue.builderProfile
    ) {
      const builderHost =
        this.props.lot.extensionValue.builderProfile.builderHost;
      if (builderHost) {
        const subdomain = builderHost.replace(/^https?:\/\//, "").split(".")[0];
        this.setState({ subdomain });
      }
    }

    const itemChanged =
      this.props.itemDetails &&
      this.props.itemDetails !== prevProps.itemDetails;

    if (itemChanged) {
      this.setState({ hasPopulatedForm: false }, () => {
        this.fetchProperty();
      });
    }
  }

  populateFormWithItemDetails = () => {
    const { itemDetails } = this.props;
    if (
      !itemDetails ||
      !this.state.formattedCategories ||
      !this.state.propertList
    )
      return;

    const {
      name,
      category,
      lotId,
      description,
      mfgName,
      modelNo,
      serialNo,
      serialNoImage,
      locationInHome,
      purchaseDate,
      price,
      typeofPurchase,
      warrantyStartDate,
      warrantyEndDate,
      smartAppId,
      registrationManual = [],
      userCareManual = [],
      limitedWarranty = [],
      receipts = [],
      serviceContracts = [],
      video = [],
      images = [],
      others = [],
    } = itemDetails;

    // Extract text and images separately
    const getTextValue = (docs) => {
      const textDoc = docs.find((d) => d.docsCategory === "Text");
      return textDoc ? textDoc.textAndUrl : "";
    };

    const getImageDocs = (docs) => {
      return docs.filter((d) => d.docsCategory === "Images");
    };

    // Check if smartApp data exists (either from dropdown or custom)
    const hasSmartAppData =
      itemDetails.smartApp && itemDetails.smartApp.smartAppId;

    const smartApp = null; // Always null to show form, not dropdown

    const matchingProperty = this.state.propertList.data.find(
      (prop) => prop.value === itemDetails.lotId
    );
    const categoryDetail = this.state.formattedCategories.find(
      (cat) => cat.id == itemDetails.category.categoryId
    );

    this.setState({
      itemName: name || "",
      itemCategory: categoryDetail || null,
      generalDescription: description || "",
      property: matchingProperty || null,
      mfgName: mfgName || "",
      model: modelNo || "",
      serial: serialNo || "",
      serialImage: serialNoImage || null,
      serialImagePreviewUrl: serialNoImage ? serialNoImage.url : "",
      profileImages:
        itemDetails.images && Array.isArray(itemDetails.images)
          ? itemDetails.images
          : [],
      locationInHome: locationInHome || "",
      purchaseDate: purchaseDate ? new Date(purchaseDate) : null,
      price: price || "",
      typeOfPurchase: typeofPurchase
        ? { text: typeofPurchase, value: typeofPurchase }
        : null,
      warrantyStart: warrantyStartDate ? new Date(warrantyStartDate) : null,
      warrantyEnd: warrantyEndDate ? new Date(warrantyEndDate) : null,
      smartApp: smartApp,
      appName: hasSmartAppData
        ? itemDetails.smartApp.appName
        : itemDetails.appName || "",
      androidURL: hasSmartAppData
        ? itemDetails.smartApp.androidUrl
        : itemDetails.androidUrl || "",
      iosURL: hasSmartAppData
        ? itemDetails.smartApp.iosUrl
        : itemDetails.iosUrl || "",
      showAddApp: hasSmartAppData || !!itemDetails.appName, // Show form when smartApp data exists
      registration: getTextValue(registrationManual),
      registrationImages: getImageDocs(registrationManual),
      userCareManual: getTextValue(userCareManual),
      userCareManualImages: getImageDocs(userCareManual),
      limitedWarranty: getTextValue(limitedWarranty),
      limitedWarrantyImages: getImageDocs(limitedWarranty),
      receiptsImages: receipts,
      serviceContractOthersImages: serviceContracts,
      videoFile: video && video.length ? video[0] : null,
      videoPreviewUrl: video && video.length ? video[0].url : "",
      otherImages: others && others.length ? others : [],
    });
  };

  resetForm = () => {
    this.setState({
      isDragging: false,
      profileImages: [],
      uploading: false,
      uploadProgress: 0,
      selectedLotId: null,
      lotDetails: null,
      activeKey: "1",
      showDocumentInfo: true,
      lot: this.props.lot,
      editingState: {},
      registration: "",
      registrationImages: [],
      registrationImagesError: "",
      uploadResults: [],
      userCareManual: "",
      userCareManualImages: [],
      userCareManualImagesError: "",
      showBasicDetails: true,
      showItemDetail: false,
      showLinkDocument: false,
      showReceiptsotherDocs: false,
      limitedWarranty: "",
      limitedWarrantyImages: [],
      limitedWarrantyImagesError: "",
      profileImagesError: "",
      profileImagesError: "",
      expandedPanels: {},
      editCategoryIndex: null,
      itemName: "",
      itemCategory: null,
      property: null,
      smartApp: null,
      locationInHome: "",
      receiptsImages: [],
      receiptsImagesError: "",
      serviceContractOthersImages: [],
      serviceContractOthersImagesError: "",
      generalDescription: "",
      typeOfPurchase: null,
      videoFile: null,
      videoPreviewUrl: "",
      videoError: "",
      warrantyStart: null,
      warrantyEnd: null,
      serial: "",
      serialImage: null,
      serialImagePreviewUrl: "",
      serialImageError: "",
      model: "",
      price: "",
      mfgName: "",
      purchaseDate: null,
      showAddApp: false,
      appName: "",
      androidURL: "",
      iosURL: "",
      appError: "",
      subdomain: "",
    });
  };

  togglePanel = (panelName) => {
    this.setState((prevState) => ({
      [panelName]: !prevState[panelName],
    }));
  };

  // Bound methods for performance
  handleFileInputClick() {
    if (this.fileInput) this.fileInput.click();
  }

  handleRegistrationInputClick() {
    if (this.registrationInput) this.registrationInput.click();
  }

  handleUserManualInputClick() {
    if (this.userManualInput) this.userManualInput.click();
  }

  handleLimitedWarrantyInputClick() {
    if (this.limitedWarrantyInput) this.limitedWarrantyInput.click();
  }

  handleReceiptsInputClick() {
    if (this.receiptsInput) this.receiptsInput.click();
  }

  handleServiceContractInputClick() {
    if (this.serviceContractOthersInput)
      this.serviceContractOthersInput.click();
  }

  handleVideoInputClick() {
    if (this.videoInputRef) this.videoInputRef.click();
  }

  handleSerialImageInputClick() {
    if (this.serialImageInputRef) this.serialImageInputRef.click();
  }

  handlePropertyChange(ref) {
    this.onSelectChange(ref, "property");
  }

  handleCategoryChange(ref) {
    this.onSelectChange(ref, "itemCategory");
  }

  handleTypeOfPurchaseChange(ref) {
    this.onSelectChange(ref, "typeOfPurchase");
  }

  handleSmartAppChange(ref) {
    this.onSelectChange(ref, "smartApp");
  }

  handleGeneralDescriptionChange(e) {
    this.setState({ generalDescription: e.target.value });
  }

  handleShowBasicDetailsToggle() {
    this.togglePanel("showBasicDetails");
  }

  handleShowItemDetailToggle() {
    this.togglePanel("showItemDetail");
  }

  handleShowLinkDocumentToggle() {
    this.togglePanel("showLinkDocument");
  }

  handleShowReceiptsToggle() {
    this.togglePanel("showReceiptsotherDocs");
  }

  handleShowOtherDocsToggle() {
    this.togglePanel("showOtherDocs");
  }

  // Sanitize input to prevent XSS
  sanitizeInput = (value) => {
    if (typeof value !== "string") return value;
    return value
      .replace(/<script[^>]*>.*?<\/script>/gi, "")
      .replace(/<[^>]*>/g, "");
  };

  handleInputChange = (event) => {
    if (!event || !event.target) return;
    const { name, value } = event.target;
    const sanitizedValue = this.sanitizeInput(value);

    if (name === "itemName" && sanitizedValue.length > 150) {
      this.setState({ error: "Name must be 150 characters or fewer." });
      return;
    }

    // Clear app error when user modifies app-related fields
    const updates = {
      [name]: sanitizedValue,
      error: "",
    };

    if (["appName", "androidURL", "iosURL"].includes(name)) {
      updates.appError = "";
    }

    this.setState(updates);
  };

  onChangepurchaseDate = (date) => {
    this.setState({ purchaseDate: date });
  };
  onChangeWarrantyStart = (date) => {
    this.setState({ warrantyStart: date });
  };

  onChangewarrantyEnd = (date) => {
    const { warrantyStart } = this.state;

    let error = "";
    if (warrantyStart && date && new Date(date) < new Date(warrantyStart)) {
      error = "Warranty end date cannot be before start date.";
    }

    this.setState({
      warrantyEnd: date,
      warrantyError: error,
    });
  };

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value,
    });
  };

  fetchProperty = () => {
    this.props.dispatch({
      type: LotActionType.GET_SELECT_LIST_HOMEOWNER_LOT_ASYNC,
      callback: (data) => {
        this.setState({ propertList: data }, () => {
          const { itemDetails } = this.props;
          if (
            itemDetails &&
            itemDetails.lotId &&
            !this.state.hasPopulatedForm
          ) {
            const matchingProperty = data.data.find(
              (prop) => prop.value === itemDetails.lotId
            );
            if (matchingProperty) {
              this.setState({ property: matchingProperty }, () => {
                this.fetchItemCategoriesHo();
              });
            }
          }
        });
      },
    });
  };

  fetchSmartApp = () => {
    console.log("Fetched smart app list:");
    // Add null check for subdomain before fetching
    if (!this.state.subdomain) {
      console.warn("Cannot fetch smart app: subdomain is not available");
      return;
    }
    const { builderProfile } = this.state.property.extensionValue;
    // Prevent duplicate requests
    if (this.smartAppFetching) return;
    this.smartAppFetching = true;

    this.props.dispatch({
      type: LotActionType.GET_SMART_APP_ASYNC,
      params: {
        subDomain: this.state.subdomain,
        builderHost: builderProfile.builderHost,
      },
      callback: (data) => {
        console.log(
          "Smart app fetch response:",
          data.data.data.builderUploaded
        );
        this.smartAppFetching = false;
        const smartAppListFormatted = data.data.data.builderUploaded.map(
          (app) => ({
            text: app.appName,
            value: app.appName,
            id: app.id,
          })
        );
        console.log("Fetched smart app list:", smartAppListFormatted);
        this.setState({
          smartAppList: smartAppListFormatted,
        });
      },
    });
  };

  getUploadFile = async (files) => {
    if (!files || files.length === 0) return;

    const fieldName = files[0].fieldName;
    const current = this.state[fieldName] || [];
    this.setState({ loading: true });

    try {
      const uploaded = await Promise.all(
        files.map((file) => this.uploadFileDirectly(file))
      );

      const validUploaded = uploaded.filter((file) => file.uploadedFileId);

      const existingKeys = new Set(
        current.map(
          (file) => `${file.name}_${file.size}_${file.uploadedFileId}`
        )
      );

      const newFiles = validUploaded.filter(
        (file) =>
          !existingKeys.has(`${file.name}_${file.size}_${file.uploadedFileId}`)
      );

      const merged = [...current, ...newFiles];

      this.setState({
        [fieldName]: merged,
        [`${fieldName}Error`]: "",
        loading: false,
      });
    } catch (error) {
      this.setState({
        [`${fieldName}Error`]: "File upload failed.",
        loading: false,
      });
    }
  };

  uploadFileDirectly = async (fileObj) => {
    const { property } = this.state;

    // Validate inputs
    if (
      !property ||
      !property.extensionValue ||
      !property.extensionValue.builderProfile
    ) {
      throw new Error(
        "Cannot upload file: property or builderProfile is missing"
      );
    }

    const { builderProfile } = property.extensionValue;

    // Validate URL to prevent SSRF
    if (
      !builderProfile.builderHost ||
      !builderProfile.builderHost.startsWith("https://")
    ) {
      throw new Error("Invalid or insecure host URL");
    }

    const formData = new FormData();
    formData.append("File", fileObj.file);
    formData.append("GroupName", fileObj.groupCategoryId);

    const response = await fetch(
      `${builderProfile.builderHost}/api/v2/homeowner/inventory/items/add/file`,
      {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "SiteOne_Services_token"
          )}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        `Upload failed: ${response.status} ${response.statusText}`
      );
    }

    const result = await response.json();

    return {
      ...fileObj,
      uploadedFileId: result.data,
    };
  };

  handleUploadImages = async (e, fieldName) => {
    const files = Array.from(e.target.files);
    const current = this.state[fieldName] || [];
    const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB
    const MAX_FILES_LIMIT = 3;
    if (
      [
        "registrationImages",
        "userCareManualImages",
        "limitedWarrantyImages",
        "receiptsImages",
      ].includes(fieldName) &&
      files.length + current.length > MAX_FILES_LIMIT
    ) {
      this.setState({
        [`${fieldName}Error`]: `You can only upload up to ${MAX_FILES_LIMIT} files.`,
      });
      return;
    }
    const imageTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/svg+xml",
      "image/heic",
      "image/heif",
      "image/gif",
      "image/tiff",
      "image/webp",
    ];
    const imageExtensions = [
      ".png",
      ".jpg",
      ".jpeg",
      ".svg",
      ".heic",
      ".heif",
      ".gif",
      ".tiff",
      ".webp",
    ];
    const documentTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/plain",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/vnd.apple.numbers",
      "application/vnd.apple.pages",
    ];
    const allowedTypesMap = {
      registrationImages: [...imageTypes, ...documentTypes],
      userCareManualImages: [...imageTypes, ...documentTypes],
      limitedWarrantyImages: [...imageTypes, ...documentTypes],
      receiptsImages: [...imageTypes, ...documentTypes],
      serviceContractOthersImages: [...imageTypes, ...documentTypes],
    };
    const allowedTypes = allowedTypesMap[fieldName];
    const documentExtensions = [
      ".pdf",
      ".doc",
      ".docx",
      ".xls",
      ".xlsx",
      ".txt",
      ".ppt",
      ".pptx",
      ".numbers",
      ".pages",
    ];
    const accepted = await Promise.all(
      files.map(async (file) => {
        const fileExtension = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        const isAllowedType =
          allowedTypes.includes(file.type) ||
          imageExtensions.includes(fileExtension) ||
          documentExtensions.includes(fileExtension);
        const isSizeValid = file.size <= MAX_FILE_SIZE;
        if (!isSizeValid) return null;

        if (fileExtension === ".heic" || fileExtension === ".heif") {
          try {
            const convertedBlob = await heic2any({
              blob: file,
              toType: "image/jpeg",
              quality: 0.8,
            });
            const newFileName = `${file.name.split(".")[0]}.jpeg`;
            return new File([convertedBlob], newFileName, {
              type: "image/jpeg",
              lastModified: file.lastModified,
            });
          } catch (error) {
            console.error("HEIC conversion failed:", error);
            return null;
          }
        }

        if (
          fileExtension === ".tiff" ||
          fileExtension === ".tif" ||
          file.type === "image/tiff"
        ) {
          try {
            const jpegBlob = await convertTiffToJpeg(file);
            const newFileName = `${file.name.split(".")[0]}.jpeg`;
            const jpegFile = new File([jpegBlob], newFileName, {
              type: "image/jpeg",
              lastModified: file.lastModified,
            });
            return jpegFile;
          } catch (error) {
            console.error("TIFF conversion failed:", error);
            return null;
          }
        }
        return isAllowedType ? file : null;
      })
    ).then((results) => results.filter(Boolean));
    if (accepted.length !== files.length) {
      let errorMessage;
      if (
        [
          "registrationImages",
          "userCareManualImages",
          "limitedWarrantyImages",
          "receiptsImages",
          "serviceContractOthersImages",
        ].includes(fieldName)
      ) {
        errorMessage =
          "Only .pdf, .doc, .docx, .xls, .xlsx, .txt, .jpg, .jpeg, .png, .heic, .gif, .ppt, .pptx, .numbers, .pages, .tiff, .webp files under 100MB are allowed.";
      } else {
        errorMessage =
          "Only SVG, PNG, JPG, JPEG files under 100MB are allowed.";
      }

      this.setState({
        [`${fieldName}Error`]: errorMessage,
      });
      return;
    }

    const groupInfo = GroupCategory[fieldName];
    const filesWithMetadata = accepted.map((file) => ({
      id: uuidv4(),
      name: file.name,
      size: file.size,
      type: file.type,
      file,
      groupCategoryId: groupInfo.id,
      groupCategoryName: groupInfo.name,
      fieldName,
    }));
    this.getUploadFile(filesWithMetadata);
  };

  removeUploadedImage = (index, fieldName) => {
    const updated = [...this.state[fieldName]];
    updated.splice(index, 1);
    this.setState({ [fieldName]: updated });
  };

  handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "video/mp4",
      "video/webm",
      "video/quicktime",
      "video/hevc",
    ];
    const isAcceptedType = allowedTypes.includes(file.type);
    const isValidSize = file.size <= 100 * 1024 * 1024;

    if (!isAcceptedType) {
      this.setState({
        videoError: "Only MP4, WebM, MOV, and HEVC formats are allowed.",
        videoFile: null,
        videoPreviewUrl: "",
      });
      return;
    }

    if (!isValidSize) {
      this.setState({
        videoError: "Video must be under 100MB.",
        videoFile: null,
        videoPreviewUrl: "",
      });
      return;
    }

    const previewUrl = URL.createObjectURL(file);

    const videoWithMetadata = {
      file,
      id: uuidv4(),
      name: file.name,
      size: file.size,
      type: file.type,
      groupCategoryId: 2,
      groupCategoryName: "Video",
      fieldName: "videoFile",
    };

    this.setState(
      {
        videoFile: videoWithMetadata,
        videoPreviewUrl: previewUrl,
        videoError: "",
      },
      () => {
        this.getVideoUploadFile(videoWithMetadata);
      }
    );
  };

  getVideoUploadFile = async (fileObj) => {
    const fieldName = "videoFile";
    this.setState({ loading: true });

    try {
      const uploaded = await this.uploadFileDirectly(fileObj);

      this.setState({
        videoFile: uploaded,
        videoError: "",
        loading: false,
      });
    } catch (error) {
      this.setState({
        videoError: "Video upload failed",
        loading: false,
      });
    }
  };

  handleDeleteVideo = () => {
    const { videoFile, deletedFiles } = this.state;
    if (videoFile) {
      deletedFiles.push({
        Id: videoFile.uploadedFileId || videoFile.id,
        GroupName: 2,
      });
    }

    this.setState({
      videoFile: null,
      videoPreviewUrl: null,
      videoError: "",
      deletedFiles,
    });

    if (this.videoInputRef) {
      this.videoInputRef.value = "";
    }
  };

  handleSerialImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/svg+xml",
      "image/heic",
      "image/heif",
      "image/webp",
    ];
    const allowedExtensions = [
      ".png",
      ".jpg",
      ".jpeg",
      ".svg",
      ".heic",
      ".heif",
      ".webp",
    ];
    const fileExtension = file.name
      .substring(file.name.lastIndexOf("."))
      .toLowerCase();
    const isAcceptedType =
      allowedTypes.includes(file.type) ||
      allowedExtensions.includes(fileExtension);
    const isValidSize = file.size <= 100 * 1024 * 1024;

    if (!isAcceptedType) {
      this.setState({
        serialImageError:
          "Only PNG, JPG, JPEG, SVG, HEIC, HEIF, and WEBP formats are allowed.",
        serialImage: null,
        serialImagePreviewUrl: "",
      });
      return;
    }

    if (!isValidSize) {
      this.setState({
        serialImageError: "Image must be under 100MB.",
        serialImage: null,
        serialImagePreviewUrl: "",
      });
      return;
    }

    let processedFile = file;

    if (fileExtension === ".heic" || fileExtension === ".heif") {
      try {
        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.8,
        });
        const newFileName = `${file.name.split(".")[0]}.jpeg`;
        processedFile = new File([convertedBlob], newFileName, {
          type: "image/jpeg",
          lastModified: file.lastModified,
        });
      } catch (error) {
        console.error("HEIC conversion failed:", error);
        this.setState({
          serialImageError: "Failed to convert HEIC/HEIF image.",
          serialImage: null,
          serialImagePreviewUrl: "",
        });
        return;
      }
    }

    const previewUrl = URL.createObjectURL(processedFile);

    const imageWithMetadata = {
      file: processedFile,
      id: uuidv4(),
      name: processedFile.name,
      size: processedFile.size,
      type: processedFile.type,
      groupCategoryId: 8,
      groupCategoryName: "SerialImage",
      fieldName: "serialImage",
    };

    this.setState(
      {
        serialImage: imageWithMetadata,
        serialImagePreviewUrl: previewUrl,
        serialImageError: "",
      },
      () => {
        this.getSerialImageUploadFile(imageWithMetadata);
      }
    );
  };

  getSerialImageUploadFile = async (fileObj) => {
    this.setState({ loading: true });

    try {
      const uploaded = await this.uploadFileDirectly(fileObj);

      this.setState({
        serialImage: uploaded,
        serialImageError: "",
        loading: false,
      });
    } catch (error) {
      this.setState({
        serialImageError: "Image upload failed",
        loading: false,
      });
    }
  };

  handleDeleteSerialImage = () => {
    const { serialImage, deletedFiles } = this.state;
    if (serialImage) {
      deletedFiles.push({
        Id: serialImage.uploadedFileId || serialImage.id,
        GroupName: 1,
      });
    }

    this.setState({
      serialImage: null,
      serialImagePreviewUrl: null,
      serialImageError: "",
      deletedFiles,
    });

    if (this.serialImageInputRef) {
      this.serialImageInputRef.value = "";
    }
  };

  // Memoize file type icon mapping for performance
  fileTypeIconCache = new Map();

  renderFileTypeIcon = (item) => {
    if (!item) return other;

    const fileName = item.fileName || item.name;
    if (!fileName) return other;

    // Check cache first
    const cacheKey = `${fileName}_${item.type || ""}`;
    if (this.fileTypeIconCache.has(cacheKey)) {
      return this.fileTypeIconCache.get(cacheKey);
    }

    const extWord = ["doc", "docx"];
    const extExcel = ["xls", "xlsx"];
    const extPpt = ["ppt", "pptx"];
    const extImage = ["jpg", "jpeg", "png", "gif", "svg", "webp"];
    const extVideo = ["mp4", "m4v", "mid", "mkv", "webm", "mov", "avi", "wmv"];

    const ext = fileName && fileName.split(".").pop().toLowerCase();
    let icon;

    if (extWord.includes(ext)) {
      icon = word;
    } else if (extExcel.includes(ext)) {
      icon = excel;
    } else if (extPpt.includes(ext)) {
      icon = ppt;
    } else if (extVideo.includes(ext)) {
      icon = video;
    } else if (ext === "pdf") {
      icon = pdf;
    } else if (extImage.includes(ext)) {
      icon =
        item.thumbnailUrl ||
        item.url ||
        item.textAndUrl ||
        (item.file ? URL.createObjectURL(item.file) : null) ||
        other;
    } else {
      icon = other;
    }

    // Cache the result
    this.fileTypeIconCache.set(cacheKey, icon);
    return icon;
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handleDragLeave = () => {
    this.setState({ isDragging: false });
  };

  handleDrop = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });

    const files = Array.from(e.dataTransfer.files);

    const accepted = [];
    const rejected = [];

    files.forEach((file) => {
      if (
        ["application/pdf", "image/png", "image/jpg", "image/jpeg", "image/webp"].includes(
          file.type
        )
      ) {
        accepted.push(file);
      } else {
        rejected.push(file);
      }
    });

    if (this.props.onDrop) {
      this.props.onDrop(accepted, rejected);
    }
  };

  fetchItemCategoriesHo = () => {
    const { property, hasPopulatedForm } = this.state;
    if (!property || !property.extensionValue) return;

    const { builderProfile } = property.extensionValue;

    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_INVENTORY_CATEGORY_ASYNC,
      params: {
        headers: { url: builderProfile.builderHost },
        lotId: property.value,
      },
      callback: (data) => {
        const categoryListing = data.data || [];
        const flattenedCategories = categoryListing.map((category) => ({
          text: category.name,
          value: category.name,
          id: category.id,
        }));

        this.setState(
          {
            categoryListing,
            formattedCategories: flattenedCategories,
          },
          () => {
            const { itemDetails } = this.props;
            if (
              itemDetails &&
              itemDetails.category &&
              itemDetails.category.categoryId &&
              !hasPopulatedForm
            ) {
              this.setState(
                {
                  hasPopulatedForm: true,
                },
                () => {
                  this.populateFormWithItemDetails();
                }
              );
            }
          }
        );
      },
    });
  };

  handleDeleteUploadedImage = (index, fieldName) => {
    const currentFiles = [...this.state[fieldName]];
    const removedFile = currentFiles[index];

    const updated = [...currentFiles];
    updated.splice(index, 1);

    const deletedFiles = [...this.state.deletedFiles];

    if (removedFile) {
      const fileId = removedFile.uploadedFileId || removedFile.id;
      const groupName = GroupCategory[fieldName] && GroupCategory[fieldName].id;

      if (fileId) {
        deletedFiles.push({
          Id: fileId,
          GroupName: groupName,
        });
      }
    }
    this.setState({
      [fieldName]: updated,
      deletedFiles,
    });
    if (this.fileInput) {
      this.fileInput.value = "";
    }
    if (this.userManualInput) {
      this.userManualInput.value = "";
    }
    if (this.registrationInput) {
      this.registrationInput.value = "";
    }
    if (this.limitedWarrantyInput) {
      this.limitedWarrantyInput.value = "";
    }
    if (this.receiptsInput) {
      this.receiptsInput.value = "";
    }
    if (this.serviceContractOthersInput) {
      this.serviceContractOthersInput.value = "";
    }
  };

  handleFileChange = (e, fieldName) => {
    const selectedFiles = Array.from(e.target.files);
    if (selectedFiles.length === 0) return;
    const current = this.state[fieldName] || [];
    if (selectedFiles.length + current.length > 1) {
      this.setState({
        profileImagesError: "You are allowed to upload a single file only.",
      });
      return;
    }
    const allowedTypes = [
      "image/png",
      "image/jpg",
      "image/jpeg",
      "image/svg+xml",
      "image/heic",
      "image/heif",
      "image/gif",
      "image/tiff",
      "image/webp",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/plain",
      "text/csv",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "video/mp4",
      "video/webm",
      "video/quicktime",
      "video/hevc",
    ];
    const accepted = selectedFiles.filter((file) => {
      const isAcceptedType = allowedTypes.includes(file.type);
      const isValidSize = file.size <= 100 * 1024 * 1024;
      const isValidExtension = this.isDocumentFile(file.name);
      return (isAcceptedType || isValidExtension) && isValidSize;
    });
    if (accepted.length !== selectedFiles.length) {
      this.setState({
        profileImagesError:
          "Each file must be under 100MB and in supported format (images, documents, videos).",
      });
      return;
    }
    const filesWithMetadata = accepted.map((file) => ({
      id: uuidv4(),
      name: file.name,
      size: file.size,
      type: file.type,
      file,
      groupCategoryId: 1,
      groupCategoryName: "Image",
      fieldName,
    }));
    this.getUploadFile(filesWithMetadata);
  };

  onSubmit = () => {
    const {
      itemName,
      itemCategory,
      property,
      generalDescription,
      mfgName,
      model,
      serial,
      serialImage,
      locationInHome,
      purchaseDate,
      price,
      typeOfPurchase,
      registration,
      registrationImages,
      userCareManual,
      userCareManualImages,
      limitedWarranty,
      limitedWarrantyImages,
      receiptsImages,
      serviceContractOthersImages,
      warrantyStart,
      warrantyEnd,
      videoFile,
      profileImages,
      smartApp,
      deletedFiles,
      appName,
      androidURL,
      iosURL,
    } = this.state;

    // 1. Combine all uploaded files
    let allFiles = [].concat(
      serialImage ? [serialImage] : [],
      registrationImages || [],
      userCareManualImages || [],
      limitedWarrantyImages || [],
      receiptsImages || [],
      serviceContractOthersImages || [],
      videoFile ? [videoFile] : [],
      profileImages || []
    );

    // 2. Collect uploadedFileIds
    const fileIds = allFiles
      .map((file) => file.uploadedFileId || file.id)
      .filter((id) => !!id);

    // 3. Always send text values
    const RegistrationText = registration || "";
    const UseCareManualText = userCareManual || "";
    const LimitedWarrantyText = limitedWarranty || "";

    // Validate price
    if (!price && price !== 0) {
      this.setState({ error: "Price is required." });
      return;
    }

    // 4. Normalize deleted file list with fallback ID logic
    const normalizedDeletedFiles = (deletedFiles || []).map((item) => ({
      Id: item.Id || item.uploadedFileId || item.id,
      GroupName: item.GroupName || item.groupCategoryId || 0,
    }));

    const requestModel = {
      Id: this.props.itemDetails.id,
      CategoryId: itemCategory && itemCategory.id ? itemCategory.id : "",
      LotId: property && property.value ? property.value : "",
      Name: itemName,
      Description: generalDescription,
      MFGName: mfgName,
      ModelNo: model,
      SerialNo: serial,
      LocationInHome: locationInHome,
      Price: parseFloat(price) || 0,
      PurchaseDate: purchaseDate ? new Date(purchaseDate).toISOString() : null,
      TypeofPurchase:
        typeOfPurchase && typeOfPurchase.value ? typeOfPurchase.value : "",
      SmartAppId: appName ? null : smartApp && smartApp.id ? smartApp.id : null,
      WarrantyStartDate: warrantyStart
        ? new Date(warrantyStart).toISOString()
        : null,
      WarrantyEndDate: warrantyEnd ? new Date(warrantyEnd).toISOString() : null,
      RegistrationText,
      UseCareManualText,
      LimitedWarrantyText,
      FileIds: fileIds,
      DeletedFileIds: normalizedDeletedFiles,
      IsBuilderUploaded: this.props.itemDetails.isBuilderUploaded,
      AppName: smartApp && smartApp.id ? "" : appName,
      AndroidUrl: smartApp && smartApp.id ? "" : androidURL,
      IosUrl: smartApp && smartApp.id ? "" : iosURL,
    };

    const { builderProfile } = this.props.lot.extensionValue;
    const hasExistingApp = smartApp && smartApp.id;
    const hasNewApp = appName && appName.trim().length > 0;

    if (hasExistingApp && hasNewApp) {
      this.setState({
        appError:
          "Please choose either an existing SMART App or add a new one, not both",
      });
      return;
    }

    if (appName && !androidURL && !iosURL) {
      this.setState({
        appError:
          "Please enter either the Android URL or the iOS URL for the app",
      });
      return;
    }

    // 6. Dispatch to update
    this.props.dispatch({
      type: LotActionType.UPDATE_HOMEOWNER_INVENTORY_ITEM,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        data: requestModel,
      },
      callback: (data) => {
        this.props.fetchInventoryCategories();
        this.props.closeModal();
      },
    });
  };

  toggleApp = () => {
    this.setState((prevState) => ({
      showAddApp: !prevState.showAddApp,
      // Clear fields when switching modes
      smartApp: !prevState.showAddApp ? null : prevState.smartApp,
      appName: prevState.showAddApp ? "" : prevState.appName,
      androidURL: prevState.showAddApp ? "" : prevState.androidURL,
      iosURL: prevState.showAddApp ? "" : prevState.iosURL,
      appError: "",
    }));
  };

  isImageFile = (fileType) => {
    const imageTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/svg+xml",
      "image/heic",
      "image/heif",
      "image/gif",
      "image/tiff",
    ];
    return imageTypes.includes(fileType);
  };

  isDocumentFile = (fileName) => {
    const allowedExtensions = [
      "pdf",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "csv",
      "txt",
      "ppt",
      "pptx",
      "numbers",
      "pages",
      "tiff",
      "odt",
      "ods",
      "rtf",
      "xlsm",
      "xltx",
      "png",
      "jpeg",
      "jpg",
      "heic",
      "heif",
      "svg",
      "gif",
      "xlsb",
      "mp4",
    ];
    const ext = fileName.split(".").pop().toLowerCase();
    return allowedExtensions.includes(ext);
  };

  handlePreviewFile = (file, index) => {
    const fileUrl = file.file
      ? URL.createObjectURL(file.file)
      : file.url || file.textAndUrl;
    const fileName =
      file.name || file.fileName || (file.file && file.file.name);
    const fileExt = fileName ? fileName.split(".").pop().toLowerCase() : "";

    this.setState({
      previewModalOpen: true,
      previewContent: { url: fileUrl, fileName, type: fileExt },
    });
  };

  closePreview = () => {
    this.setState({ previewModalOpen: false, previewContent: null });
  };

  renderPreviewModal = () => {
    const { previewModalOpen, previewContent } = this.state;
    if (!previewContent) return null;

    const fileExt = previewContent.type;
    const imageFiles = ["jpg", "jpeg", "png", "gif", "svg", "webp"];
    const videoFiles = ["mp4", "webm", "mov", "avi"];
    const officeFiles = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];

    const renderPreview = () => {
      if (imageFiles.includes(fileExt)) {
        return (
          <img
            src={previewContent.url}
            alt={previewContent.fileName}
            style={{ maxHeight: "80vh", maxWidth: "100%" }}
          />
        );
      }
      if (videoFiles.includes(fileExt)) {
        return (
          <video controls style={{ maxWidth: "100%", maxHeight: "80vh" }}>
            <source src={previewContent.url} type={`video/${fileExt}`} />
            Your browser does not support the video tag.
          </video>
        );
      }
      if (fileExt === "pdf" || fileExt === "txt") {
        return (
          <iframe
            src={previewContent.url}
            title={previewContent.fileName}
            style={{ width: "100%", height: "70vh", border: "none" }}
          />
        );
      }
      if (officeFiles.includes(fileExt)) {
        const isBlob = previewContent.url.startsWith("blob:");
        if (isBlob) {
          return (
            <div style={{ padding: "20px", textAlign: "center" }}>
              <p>document preview is not available for local files.</p>
              <button
                onClick={() => window.open(previewContent.url, "_blank")}
                className="btn btn-primary"
              >
                Download File
              </button>
            </div>
          );
        }
        return (
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
              previewContent.url
            )}`}
            style={{ width: "100%", height: "70vh", border: "none" }}
            title={previewContent.fileName}
          />
        );
      }
      return (
        <div style={{ padding: "20px" }}>
          <p>Preview not available.</p>
          <button
            onClick={() => window.open(previewContent.url, "_blank")}
            className="btn btn-primary"
          >
            Open in New Tab
          </button>
        </div>
      );
    };

    return (
      <Modal
        show={previewModalOpen}
        onHide={this.closePreview}
        centered
        className="custom-preview-modal"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{previewContent.fileName}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center", minHeight: "500px" }}>
          {renderPreview()}
        </Modal.Body>
      </Modal>
    );
  };

  render() {
    const {
      isDragging,
      showBasicDetails,
      showItemDetail,
      videoFile,
      showLinkDocument,
      showReceiptsotherDocs,
      loading,
      showOtherDocs,
      showAddApp,
    } = this.state;
    const { isOpen, closeModal, accept } = this.props;

    return (
      <React.Fragment>
        <Modal
          show={isOpen}
          onHide={closeModal}
          backdrop="static"
          dialogClassName="slide-in-modal"
          className="modal-right"
        >
          <Modal.Header className="modal-header-profile">
            <div className="modal-header">
              <i
                className="fa fa-chevron-left arrow-btn"
                aria-hidden="true"
                onClick={closeModal}
              ></i>
              <Modal.Title className="modal-title-custom">
                Edit Item
              </Modal.Title>
            </div>
          </Modal.Header>

          <Modal.Body className="modal-body-add-doc scrollable-modal-body">
            <div className="image-upload-section">
              {this.state.profileImages.length > 0 ? (
                <div style={{ width: "100%" }}>
                  {this.state.profileImages.map((doc, index) => {
                    const fileTypeIcon = this.renderFileTypeIcon(
                      doc.file ? doc.file : doc
                    );

                    return (
                      <div key={index} className="item-card-content">
                        <div
                          className="item-card"
                          onClick={() => this.handlePreviewFile(doc, index)}
                          style={{ cursor: "pointer" }}
                        >
                          {/* Left: icon */}
                          <div className="left-section">
                            {this.isImageFile(
                              doc.type || (doc.file && doc.file.type)
                            ) ? (
                              <img
                                src={
                                  doc.file
                                    ? URL.createObjectURL(doc.file)
                                    : fileTypeIcon
                                }
                                alt="preview"
                                className="doc-icon"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <img
                                src={fileTypeIcon}
                                alt="file icon"
                                className="doc-icon"
                              />
                            )}
                          </div>
                          {/* Middle: file name */}
                          <div
                            className="middle-section"
                            title={doc.name || doc.fileName}
                          >
                            <div className="doc-title">
                              {getTruncatedFilename(doc)}
                            </div>
                          </div>
                          {/* Right: delete only */}
                          <div className="right-section">
                            <i
                              className="fa fa-trash"
                              style={{
                                color: "red",
                                cursor: "pointer",
                                marginLeft: "10px",
                                fontSize: "20px",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                this.handleDeleteUploadedImage(
                                  index,
                                  "profileImages"
                                );
                              }}
                              title="Delete image"
                            ></i>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : this.props.isEdit &&
                this.props.selectedCategory &&
                this.props.selectedCategory.imageUrl ? (
                <img
                  className="doc-img-upload"
                  onClick={this.handleFileInputClick}
                  src={this.props.selectedCategory.imageUrl}
                  alt="Existing Preview"
                />
              ) : (
                <div
                  className="inventory-category-img"
                  onClick={this.handleFileInputClick}
                >
                  <i class="fa fa-picture-o" aria-hidden="true"></i>
                </div>
              )}

              <div
                className={`modal-dropzone ${isDragging ? "dragging" : ""}`}
                onDragOver={this.handleDragOver}
                onDragLeave={this.handleDragLeave}
                onDrop={this.handleDrop}
              >
                <input
                  type="file"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.ppt,.pptx,.numbers,.pages,.tiff,.odt,.ods,.rtf,.xlsm,.xltx,.png,.jpeg,.jpg,.heic,.heif,.svg,.gif,.xlsb,.mp4,.mov,.avi,.mkv,.webm,.hevc,.webp"
                  multiple
                  disabled={!this.state.property}
                  onChange={(ref) =>
                    this.handleFileChange(ref, "profileImages")
                  }
                  style={{ display: "none" }}
                  ref={(ref) => (this.fileInput = ref)}
                />
                <button
                  type="button"
                  className="upload-document-btn"
                  onClick={this.handleFileInputClick}
                  disabled={!this.state.property}
                  style={{
                    border: !this.state.property ? "none" : "1px solid #3c5e9e",
                  }}
                >
                  <i class="fa fa-picture-o" aria-hidden="true"></i> Upload File
                </button>
              </div>
            </div>

            {this.state.profileImagesError && (
              <div
                className="error-message"
                style={{ color: "red", marginBottom: "10px" }}
              >
                {this.state.profileImagesError}
              </div>
            )}
            {!this.state.property ? (
              <p style={{ color: "red", fontSize: "12px" }}>
                Select 'Property' to enable upload file
              </p>
            ) : (
              ""
            )}
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Row className="clearfix">
                <Col sm={12}>
                  <Tab.Content animation className="add-inventory-item">
                    <Tab.Pane eventKey="first">
                      <Form
                        ref={(c) => {
                          this.form = c;
                        }}
                        onSubmit={this.onSubmit}
                      >
                        {/* Basic Detail panel */}
                        <Panel>
                          <Panel.Heading
                            onClick={this.handleShowBasicDetailsToggle}
                          >
                            <div className="accordion-header">
                              <span>
                                <span
                                  className={`glyphicon arrow-icon ${
                                    showBasicDetails
                                      ? "glyphicon-chevron-up"
                                      : "glyphicon-chevron-down"
                                  }`}
                                ></span>{" "}
                                <span className="lot-titles">
                                  Basic Details
                                </span>
                              </span>
                            </div>
                          </Panel.Heading>
                          {showBasicDetails && (
                            <Panel.Body>
                              <div className="box-form-body">
                                <div className="form-group">
                                  <label>
                                    Name
                                    <strong className="text-danger">*</strong>
                                  </label>
                                  <input
                                    type="text"
                                    name="itemName"
                                    value={this.state.itemName}
                                    onChange={this.handleInputChange}
                                    placeholder="Enter name"
                                    className="input-field"
                                  />
                                  {this.state.error && (
                                    <p className="error-message">
                                      {this.state.error}
                                    </p>
                                  )}
                                </div>
                                <div className="form-group">
                                  <label>
                                    Property
                                    <strong className="text-danger">*</strong>
                                  </label>

                                  <Dropdown
                                    onChange={this.handlePropertyChange}
                                    filter={true}
                                    className="filestring-dropdown filter-dropdown"
                                    onRemote={this.fetchProperty}
                                    required={true}
                                    disabled={true}
                                    options={
                                      this.state.propertList
                                        ? this.state.propertList.data
                                        : []
                                    }
                                    optionLabel="text"
                                    errorMessage="This information is required."
                                    value={this.state.property}
                                    showClear={false}
                                    name="property"
                                    placeholder="-- Please select"
                                    style={{
                                      width: "100%",
                                      display: "inline-block",
                                      // backgroundColor: "#f5f5f5",
                                      color: "#999",
                                    }}
                                  />
                                </div>
                                <div className="form-group">
                                  <label>
                                    Category
                                    <strong className="text-danger">*</strong>
                                  </label>

                                  <Dropdown
                                    onChange={this.handleCategoryChange}
                                    className="filestring-dropdown filter-dropdown"
                                    options={this.state.formattedCategories}
                                    optionLabel="text"
                                    onRemote={this.fetchItemCategoriesHo}
                                    value={this.state.itemCategory}
                                    showClear={true}
                                    name="itemCategory"
                                    placeholder="-- Please select"
                                    style={{
                                      width: "100%",
                                      display: "inline-block",
                                    }}
                                  />
                                </div>

                                <div
                                  className="form-group"
                                  style={{ margin: "-20px 0px" }}
                                >
                                  <label>General Description</label>
                                  <textarea
                                    rows={7}
                                    name="generalDescription"
                                    ref="generalDescription"
                                    placeholder="General description"
                                    className="form-control"
                                    maxLength="250"
                                    value={this.state.generalDescription}
                                    onChange={
                                      this.handleGeneralDescriptionChange
                                    }
                                  />
                                </div>
                              </div>
                            </Panel.Body>
                          )}
                        </Panel>
                        {/* Item Detail Panel */}
                        <Panel>
                          <Panel.Heading
                            onClick={this.handleShowItemDetailToggle}
                          >
                            <div className="accordion-header">
                              <span>
                                <span
                                  className={`glyphicon arrow-icon ${
                                    showItemDetail
                                      ? "glyphicon-chevron-up"
                                      : "glyphicon-chevron-down"
                                  }`}
                                ></span>
                                <span className="lot-titles">Item Details</span>
                              </span>
                            </div>
                          </Panel.Heading>
                          {showItemDetail && (
                            <Panel.Body>
                              <div className="box-form-body">
                                <div className="form-group">
                                  <label>MFG Name / Vendor</label>
                                  <input
                                    type="text"
                                    name="mfgName"
                                    value={this.state.mfgName}
                                    onChange={this.handleInputChange}
                                    placeholder="Enter name / vendor"
                                    className="input-field"
                                    max="50"
                                    maxLength="50"
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Model #</label>
                                  <input
                                    type="text"
                                    name="model"
                                    value={this.state.model}
                                    onChange={this.handleInputChange}
                                    placeholder="Enter model"
                                    className="input-field"
                                    max="50"
                                    maxLength="50"
                                  />
                                </div>{" "}
                                <div className="form-group">
                                  <label>Serial #</label>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      gap: "10px",
                                      marginBottom: "20px",
                                    }}
                                  >
                                    <input
                                      type="text"
                                      name="serial"
                                      value={this.state.serial}
                                      onChange={this.handleInputChange}
                                      placeholder="Enter serial"
                                      className="input-field"
                                      max="50"
                                      maxLength="50"
                                      style={{ flex: 1, width: "210%" }}
                                    />
                                    <span>
                                      <i
                                        className="fa fa-file-text-o"
                                        aria-hidden="true"
                                        style={{
                                          fontSize: "24px",
                                          cursor: "pointer",
                                        }}
                                        onClick={this.handleSerialImageInputClick.bind(
                                          this
                                        )}
                                      ></i>
                                      <input
                                        type="file"
                                        id="serial-image-file"
                                        name="serialImage"
                                        disabled={!this.state.property}
                                        accept="image/png, image/jpeg, image/jpg, image/svg+xml, .heic, .heif, image/webp, .webp"
                                        style={{ display: "none" }}
                                        ref={(ref) =>
                                          (this.serialImageInputRef = ref)
                                        }
                                        onChange={this.handleSerialImageChange}
                                      />
                                    </span>
                                  </div>
                                  <div className="text-danger mt-2">
                                    {this.state.serialImageError}
                                  </div>
                                  {this.state.serialImagePreviewUrl && (
                                    <div id="preview" className="mt-3">
                                      <div className="item-card-content">
                                        <div className="item-card">
                                          <div className="left-section">
                                            <img
                                              src={
                                                this.state.serialImagePreviewUrl
                                              }
                                              alt="serial preview"
                                              className="doc-icon"
                                            />
                                          </div>
                                          <div
                                            className="middle-section"
                                            title={
                                              this.state.serialImage.fileName ||
                                              this.state.serialImage.name
                                            }
                                          >
                                            <div className="doc-title">
                                              {getTruncatedFilename(
                                                this.state.serialImage
                                              )}
                                            </div>
                                          </div>
                                          <div
                                            style={{
                                              textAlign: "right",
                                            }}
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-sm"
                                              style={{ border: "none" }}
                                              onClick={
                                                this.handleDeleteSerialImage
                                              }
                                            >
                                              <i
                                                className="fa fa-trash"
                                                style={{
                                                  color: "red",
                                                  cursor: "pointer",
                                                  marginLeft: "10px",
                                                  fontSize: "20px",
                                                }}
                                              ></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>{" "}
                                <div className="form-group">
                                  <label>
                                    Location in Home
                                    <strong className="text-danger">*</strong>
                                  </label>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      gap: "10px",
                                      marginBottom: "20px",
                                    }}
                                  >
                                    <input
                                      type="text"
                                      name="locationInHome"
                                      value={this.state.locationInHome}
                                      onChange={this.handleInputChange}
                                      placeholder="Enter location in home"
                                      className="input-field"
                                      max="50"
                                      maxLength="50"
                                      style={{ flex: 1, width: "210%" }}
                                    />
                                    <span>
                                      <i
                                        className="fa fa-file-video-o"
                                        aria-hidden="true"
                                        style={{
                                          fontSize: "24px",
                                          cursor: "pointer",
                                        }}
                                        onClick={this.handleVideoInputClick}
                                      ></i>
                                      <input
                                        type="file"
                                        id="video-file"
                                        name="video"
                                        disabled={!this.state.property}
                                        accept="video/mp4, video/webm, video/quicktime, video/hevc"
                                        style={{ display: "none" }}
                                        ref={(ref) =>
                                          (this.videoInputRef = ref)
                                        }
                                        onChange={this.handleVideoChange}
                                      />
                                    </span>
                                  </div>
                                  <div className="text-danger mt-2">
                                    {this.state.videoError}
                                  </div>
                                  {this.state.videoPreviewUrl && (
                                    <div id="preview" className="mt-3">
                                      <div className="item-card-content">
                                        <div className="item-card">
                                          {/* Left: icon */}
                                          <div className="left-section">
                                            <img
                                              src={this.renderFileTypeIcon(
                                                videoFile
                                              )}
                                              alt="file icon"
                                              className="doc-icon"
                                            />
                                          </div>

                                          <div
                                            className="middle-section"
                                            title={
                                              videoFile.fileName ||
                                              videoFile.file.name
                                            }
                                          >
                                            <div className="doc-title">
                                              {getTruncatedFilename(videoFile)}
                                            </div>
                                          </div>
                                          <div
                                            style={{
                                              textAlign: "right",
                                            }}
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-sm"
                                              style={{ border: "none" }}
                                              onClick={this.handleDeleteVideo}
                                            >
                                              <i
                                                className="fa fa-trash"
                                                style={{
                                                  color: "red",
                                                  cursor: "pointer",
                                                  marginLeft: "10px",
                                                  fontSize: "20px",
                                                }}
                                              ></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="form-group ">
                                  <div>
                                    <label>Purchase Date</label>
                                    <Datetime
                                      name="purchaseDate"
                                      inputProps={{
                                        placeholder: "mm/dd/yyyy",
                                      }}
                                      value={
                                        this.state.purchaseDate
                                          ? Moment(
                                              this.state.purchaseDate
                                            ).format("MM/DD/YYYY")
                                          : null
                                      }
                                      timeFormat={false}
                                      onChange={this.onChangepurchaseDate}
                                      closeOnSelect={true}
                                      style={{
                                        width: "100%",
                                        display: "inline-block",
                                      }}
                                    />
                                  </div>
                                </div>{" "}
                                <div className="form-group">
                                  <label>
                                    Price
                                    <strong className="text-danger">*</strong>
                                  </label>
                                  <div
                                    className="input-group"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      className="input-group-prepend"
                                      style={{ marginRight: "10px" }}
                                    >
                                      <span
                                        className="input-group-text"
                                        style={{ fontSize: "18px" }}
                                      >
                                        $
                                      </span>
                                    </div>
                                    <input
                                      type="number"
                                      name="price"
                                      value={this.state.price}
                                      onChange={this.handleInputChange}
                                      placeholder="Enter price"
                                      className="input-field"
                                      min="0"
                                      step="0.01"
                                      required
                                      style={{
                                        width: "100%",
                                        display: "inline-block",
                                        border: "1px solid #dbeafe",
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label>
                                    Type of Purchase
                                    <strong className="text-danger">*</strong>
                                  </label>
                                  <Dropdown
                                    onChange={this.handleTypeOfPurchaseChange}
                                    filter={true}
                                    className="filestring-dropdown filter-dropdown"
                                    options={this.state.typeOfPurchaseList}
                                    optionLabel="text"
                                    value={this.state.typeOfPurchase}
                                    showClear={true}
                                    name="room"
                                    placeholder="-- Please select"
                                    ref={(ref) => {
                                      this.typeOfPurchase = ref;
                                    }}
                                    style={{ width: "100%" }}
                                  />{" "}
                                </div>
                              </div>
                            </Panel.Body>
                          )}
                        </Panel>
                        {/* Link and  Documents */}
                        <Panel>
                          <Panel.Heading
                            onClick={this.handleShowLinkDocumentToggle}
                          >
                            <div className="accordion-header">
                              <span>
                                <span
                                  className={`glyphicon arrow-icon ${
                                    showLinkDocument
                                      ? "glyphicon-chevron-up"
                                      : "glyphicon-chevron-down"
                                  }`}
                                ></span>

                                <span className="lot-titles">
                                  Link & Documents
                                </span>
                              </span>
                            </div>
                          </Panel.Heading>
                          {showLinkDocument && (
                            <Panel.Body>
                              {/* --- Registration --- */}
                              <div className="form-group link-document-fields">
                                <label>Registration</label>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    name="registration"
                                    value={this.state.registration}
                                    onChange={this.handleInputChange}
                                    placeholder="Enter registration link"
                                    className="input-field"
                                    style={{ flex: 1, width: "210%" }}
                                  />
                                  <span>
                                    <i
                                      className="fa fa-file-text-o"
                                      aria-hidden="true"
                                      style={{
                                        fontSize: "24px",
                                        cursor: "pointer",
                                      }}
                                      onClick={
                                        this.handleRegistrationInputClick
                                      }
                                    ></i>
                                    <input
                                      type="file"
                                      accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.jpg,.jpeg,.png,.heic,.heif,.gif,.ppt,.pptx,.numbers,.pages,.tiff,.svg,.webp"
                                      multiple
                                      disabled={!this.state.property}
                                      onChange={(ref) => {
                                        this.handleUploadImages(
                                          ref,
                                          "registrationImages"
                                        );
                                      }}
                                      style={{ display: "none" }}
                                      ref={(ref) =>
                                        (this.registrationInput = ref)
                                      }
                                    />
                                  </span>
                                </div>
                                {this.state.registrationImagesError && (
                                  <div style={{ color: "red", marginTop: 5 }}>
                                    {this.state.registrationImagesError}
                                  </div>
                                )}
                                {this.state.registrationImages.length > 0 && (
                                  <div style={{ marginTop: "20px" }}>
                                    {this.state.registrationImages.map(
                                      (doc, index) => {
                                        const fileTypeIcon =
                                          this.renderFileTypeIcon(
                                            doc.file ? doc.file : doc
                                          );

                                        return (
                                          <div
                                            key={index}
                                            className="item-card-content"
                                          >
                                            <div
                                              className="item-card"
                                              onClick={() =>
                                                this.handlePreviewFile(
                                                  doc,
                                                  index
                                                )
                                              }
                                              style={{ cursor: "pointer" }}
                                            >
                                              <div className="left-section">
                                                <img
                                                  src={fileTypeIcon}
                                                  alt="file icon"
                                                  className="doc-icon"
                                                />
                                              </div>
                                              <div
                                                className="middle-section"
                                                title={doc.name || doc.fileName}
                                              >
                                                <div className="doc-title">
                                                  {getTruncatedFilename(doc)}
                                                </div>
                                              </div>
                                              <div className="right-section">
                                                <i
                                                  className="fa fa-trash"
                                                  style={{
                                                    color: "red",
                                                    cursor: "pointer",
                                                    marginLeft: "10px",
                                                    fontSize: "20px",
                                                  }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.handleDeleteUploadedImage(
                                                      index,
                                                      "registrationImages"
                                                    );
                                                  }}
                                                  title="Delete image"
                                                ></i>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                )}
                              </div>
                              {/*User & Care Manual  */}
                              <div className="form-group link-document-fields">
                                <label>User & Care Manual</label>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    name="userCareManual"
                                    value={this.state.userCareManual}
                                    onChange={this.handleInputChange}
                                    placeholder="Enter user and care manual link"
                                    className="input-field"
                                    style={{ flex: 1, width: "210%" }}
                                  />
                                  <span>
                                    <i
                                      className="fa fa-file-text-o"
                                      aria-hidden="true"
                                      style={{
                                        fontSize: "24px",
                                        cursor: "pointer",
                                      }}
                                      onClick={this.handleUserManualInputClick}
                                    ></i>
                                    <input
                                      type="file"
                                      accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.jpg,.jpeg,.png,.heic,.heif,.gif,.ppt,.pptx,.numbers,.pages,.tiff,.svg,.webp"
                                      multiple
                                      disabled={!this.state.property}
                                      onChange={(ref) => {
                                        this.handleUploadImages(
                                          ref,
                                          "userCareManualImages"
                                        );
                                      }}
                                      style={{ display: "none" }}
                                      ref={(ref) =>
                                        (this.userManualInput = ref)
                                      }
                                    />
                                  </span>
                                </div>
                                {this.state.userCareManualImagesError && (
                                  <div style={{ color: "red", marginTop: 5 }}>
                                    {this.state.userCareManualImagesError}
                                  </div>
                                )}
                                {this.state.userCareManualImages.length > 0 && (
                                  <div style={{ marginTop: "20px" }}>
                                    {this.state.userCareManualImages.map(
                                      (doc, index) => {
                                        const fileTypeIcon =
                                          this.renderFileTypeIcon(
                                            doc.file ? doc.file : doc
                                          );

                                        return (
                                          <div
                                            key={index}
                                            className="item-card-content"
                                          >
                                            <div
                                              className="item-card"
                                              onClick={() =>
                                                this.handlePreviewFile(
                                                  doc,
                                                  index
                                                )
                                              }
                                              style={{ cursor: "pointer" }}
                                            >
                                              <div className="left-section">
                                                <img
                                                  src={fileTypeIcon}
                                                  alt="file icon"
                                                  className="doc-icon"
                                                />
                                              </div>
                                              <div
                                                className="middle-section"
                                                title={doc.name || doc.fileName}
                                              >
                                                <div className="doc-title">
                                                  {getTruncatedFilename(doc)}
                                                </div>
                                              </div>
                                              <div className="right-section">
                                                <i
                                                  className="fa fa-trash"
                                                  style={{
                                                    color: "red",
                                                    cursor: "pointer",
                                                    marginLeft: "10px",
                                                    fontSize: "20px",
                                                  }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.handleDeleteUploadedImage(
                                                      index,
                                                      "userCareManualImages"
                                                    );
                                                  }}
                                                  title="Delete image"
                                                ></i>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                )}
                              </div>
                              {/* --- Limited Warranty --- */}
                              <div className="form-group link-document-fields">
                                <label>Limited Warranty</label>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    name="limitedWarranty"
                                    value={this.state.limitedWarranty}
                                    onChange={this.handleInputChange}
                                    placeholder="Enter limited warranty link"
                                    className="input-field"
                                    style={{ flex: 1, width: "210%" }}
                                  />
                                  <span>
                                    <i
                                      className="fa fa-file-text-o"
                                      aria-hidden="true"
                                      style={{
                                        fontSize: "24px",
                                        cursor: "pointer",
                                      }}
                                      onClick={
                                        this.handleLimitedWarrantyInputClick
                                      }
                                    ></i>
                                    <input
                                      type="file"
                                      accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.jpg,.jpeg,.png,.heic,.heif,.gif,.ppt,.pptx,.numbers,.pages,.tiff,.svg,.webp"
                                      multiple
                                      disabled={!this.state.property}
                                      onChange={(ref) => {
                                        this.handleUploadImages(
                                          ref,
                                          "limitedWarrantyImages"
                                        );
                                      }}
                                      style={{ display: "none" }}
                                      ref={(ref) =>
                                        (this.limitedWarrantyInput = ref)
                                      }
                                    />
                                  </span>
                                </div>
                                {this.state.limitedWarrantyImagesError && (
                                  <div style={{ color: "red", marginTop: 5 }}>
                                    {this.state.limitedWarrantyImagesError}
                                  </div>
                                )}
                                {this.state.limitedWarrantyImages.length >
                                  0 && (
                                  <div style={{ marginTop: "20px" }}>
                                    {this.state.limitedWarrantyImages.map(
                                      (doc, index) => {
                                        const fileTypeIcon =
                                          this.renderFileTypeIcon(
                                            doc.file ? doc.file : doc
                                          );

                                        return (
                                          <div
                                            key={index}
                                            className="item-card-content"
                                          >
                                            <div
                                              className="item-card"
                                              onClick={() =>
                                                this.handlePreviewFile(
                                                  doc,
                                                  index
                                                )
                                              }
                                              style={{ cursor: "pointer" }}
                                            >
                                              <div className="left-section">
                                                <img
                                                  src={fileTypeIcon}
                                                  alt="file icon"
                                                  className="doc-icon"
                                                />
                                              </div>
                                              <div
                                                className="middle-section"
                                                title={doc.name || doc.fileName}
                                              >
                                                <div className="doc-title">
                                                  {getTruncatedFilename(doc)}
                                                </div>
                                              </div>
                                              <div className="right-section">
                                                <i
                                                  className="fa fa-trash"
                                                  style={{
                                                    color: "red",
                                                    cursor: "pointer",
                                                    marginLeft: "10px",
                                                    fontSize: "20px",
                                                  }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.handleDeleteUploadedImage(
                                                      index,
                                                      "limitedWarrantyImages"
                                                    );
                                                  }}
                                                  title="Delete image"
                                                ></i>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                )}
                              </div>

                              <div className="form-group">
                                <label>Warranty Start</label>
                                <Datetime
                                  name="warrantyStart"
                                  inputProps={{
                                    placeholder: "mm/dd/yyyy",
                                  }}
                                  value={
                                    this.state.warrantyStart
                                      ? Moment(this.state.warrantyStart).format(
                                          "MM/DD/YYYY"
                                        )
                                      : null
                                  }
                                  timeFormat={false}
                                  onChange={this.onChangeWarrantyStart}
                                  closeOnSelect={true}
                                  style={{
                                    width: "100%",
                                    display: "inline-block",
                                  }}
                                />
                              </div>
                              <div className="form-group">
                                <label>Warranty End</label>

                                <Datetime
                                  name="warrantyEnd"
                                  inputProps={{
                                    placeholder: "mm/dd/yyyy",
                                  }}
                                  timeFormat={false}
                                  value={
                                    this.state.warrantyEnd
                                      ? Moment(this.state.warrantyEnd).format(
                                          "MM/DD/YYYY"
                                        )
                                      : null
                                  }
                                  onChange={this.onChangewarrantyEnd}
                                  closeOnSelect={true}
                                  style={{
                                    width: "100%",
                                    display: "inline-block",
                                  }}
                                />
                                {this.state.warrantyError && (
                                  <div style={{ color: "red", marginTop: 5 }}>
                                    {this.state.warrantyError}
                                  </div>
                                )}
                              </div>
                            </Panel.Body>
                          )}
                        </Panel>
                        {/* Receipts and Other Docs */}
                        <Panel>
                          <Panel.Heading
                            onClick={this.handleShowReceiptsToggle}
                          >
                            <div className="accordion-header">
                              <span>
                                <span
                                  className={`glyphicon arrow-icon ${
                                    showReceiptsotherDocs
                                      ? "glyphicon-chevron-up"
                                      : "glyphicon-chevron-down"
                                  }`}
                                ></span>

                                <span className="lot-titles">
                                  Receipts & Other Docs
                                </span>
                              </span>
                            </div>
                          </Panel.Heading>
                          {showReceiptsotherDocs && (
                            <Panel.Body>
                              <div>
                                <label>Receipts</label>
                                <div className="image-upload-section">
                                  <div
                                    className={`modal-dropzone ${
                                      isDragging ? "dragging" : ""
                                    }`}
                                    onDragOver={this.handleDragOver}
                                    onDragLeave={this.handleDragLeave}
                                    onDrop={this.handleDrop}
                                  >
                                    <input
                                      type="file"
                                      accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.jpg,.jpeg,.png,.heic,.heif,.gif,.ppt,.pptx,.numbers,.pages,.tiff,.svg,.webp"
                                      multiple
                                      disabled={!this.state.property}
                                      onChange={(ref) => {
                                        this.handleUploadImages(
                                          ref,
                                          "receiptsImages"
                                        );
                                      }}
                                      style={{ display: "none" }}
                                      ref={(ref) => (this.receiptsInput = ref)}
                                    />
                                    <button
                                      type="button"
                                      className="file-upload-btn"
                                      disabled={!this.state.property}
                                      onClick={this.handleReceiptsInputClick}
                                    >
                                      Upload Document
                                      <i
                                        class="fa fa-file-text-o"
                                        style={{ fontSize: "18px" }}
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                  </div>
                                </div>
                                {this.state.receiptsImagesError && (
                                  <div style={{ color: "red", marginTop: 5 }}>
                                    {this.state.receiptsImagesError}
                                  </div>
                                )}
                                <div style={{ marginTop: "20px" }}>
                                  {this.state.receiptsImages.map(
                                    (doc, index) => {
                                      const fileTypeIcon =
                                        this.renderFileTypeIcon(
                                          doc.file ? doc.file : doc
                                        );

                                      return (
                                        <div
                                          key={index}
                                          className="item-card-content"
                                        >
                                          <div
                                            className="item-card"
                                            onClick={() =>
                                              this.handlePreviewFile(doc, index)
                                            }
                                            style={{ cursor: "pointer" }}
                                          >
                                            {/* Left: icon */}
                                            <div className="left-section">
                                              <img
                                                src={fileTypeIcon}
                                                alt="file icon"
                                                className="doc-icon"
                                              />
                                            </div>
                                            {/* Middle: file name */}
                                            <div
                                              className="middle-section"
                                              title={doc.name || doc.fileName}
                                            >
                                              <div className="doc-title">
                                                {getTruncatedFilename(doc)}
                                              </div>
                                            </div>
                                            {/* Right: delete icon */}
                                            <div className="right-section">
                                              <i
                                                className="fa fa-trash"
                                                style={{
                                                  color: "red",
                                                  cursor: "pointer",
                                                  marginLeft: "10px",
                                                  fontSize: "20px",
                                                }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  this.handleDeleteUploadedImage(
                                                    index,
                                                    "receiptsImages"
                                                  );
                                                }}
                                                title="Delete image"
                                              ></i>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                              <div>
                                <label>Service Contract & Others</label>
                                <div className="image-upload-section">
                                  <div
                                    className={`modal-dropzone ${
                                      isDragging ? "dragging" : ""
                                    }`}
                                    onDragOver={this.handleDragOver}
                                    onDragLeave={this.handleDragLeave}
                                    onDrop={this.handleDrop}
                                  >
                                    <input
                                      type="file"
                                      accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.jpg,.jpeg,.png,.heic,.heif,.gif,.ppt,.pptx,.numbers,.pages,.tiff,.svg,.webp"
                                      multiple
                                      disabled={!this.state.property}
                                      onChange={(ref) => {
                                        this.handleUploadImages(
                                          ref,
                                          "serviceContractOthersImages"
                                        );
                                      }}
                                      style={{ display: "none" }}
                                      ref={(ref) =>
                                        (this.serviceContractOthersInput = ref)
                                      }
                                    />
                                    <button
                                      type="button"
                                      className="file-upload-btn"
                                      disabled={!this.state.property}
                                      onClick={
                                        this.handleServiceContractInputClick
                                      }
                                    >
                                      Upload Document
                                      <i
                                        class="fa fa-file-text-o"
                                        style={{ fontSize: "18px" }}
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                  </div>
                                </div>
                                {this.state
                                  .serviceContractOthersImagesError && (
                                  <div style={{ color: "red", marginTop: 5 }}>
                                    {
                                      this.state
                                        .serviceContractOthersImagesError
                                    }
                                  </div>
                                )}
                                <div style={{ marginTop: "20px" }}>
                                  {this.state.serviceContractOthersImages.map(
                                    (doc, index) => {
                                      const fileTypeIcon =
                                        this.renderFileTypeIcon(
                                          doc.file ? doc.file : doc
                                        );

                                      return (
                                        <div
                                          key={index}
                                          className="item-card-content"
                                        >
                                          <div
                                            className="item-card"
                                            onClick={() =>
                                              this.handlePreviewFile(doc, index)
                                            }
                                            style={{ cursor: "pointer" }}
                                          >
                                            <div className="left-section">
                                              <img
                                                src={fileTypeIcon}
                                                alt="file icon"
                                                className="doc-icon"
                                              />
                                            </div>
                                            <div
                                              className="middle-section"
                                              title={doc.name || doc.fileName}
                                            >
                                              <div className="doc-title">
                                                {getTruncatedFilename(doc)}
                                              </div>
                                            </div>
                                            <div className="right-section">
                                              <i
                                                className="fa fa-trash"
                                                style={{
                                                  color: "red",
                                                  cursor: "pointer",
                                                  marginLeft: "10px",
                                                  fontSize: "20px",
                                                }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  this.handleDeleteUploadedImage(
                                                    index,
                                                    "serviceContractOthersImages"
                                                  );
                                                }}
                                                title="Delete image"
                                              ></i>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            </Panel.Body>
                          )}
                        </Panel>

                        {this.state.otherImages &&
                        this.state.otherImages.length ? (
                          <Panel>
                            <Panel.Heading
                              onClick={this.handleShowOtherDocsToggle}
                            >
                              <div className="accordion-header">
                                <span>
                                  <span
                                    className={`glyphicon arrow-icon ${
                                      showOtherDocs
                                        ? "glyphicon-chevron-up"
                                        : "glyphicon-chevron-down"
                                    }`}
                                  ></span>
                                  <span className="lot-titles">Other</span>
                                </span>
                              </div>
                            </Panel.Heading>
                            {showOtherDocs && (
                              <Panel.Body>
                                <div style={{ marginTop: "20px" }}>
                                  {this.state.otherImages.map((doc, index) => {
                                    const fileTypeIcon =
                                      this.renderFileTypeIcon(
                                        doc.file ? doc.file : doc
                                      );

                                    return (
                                      <div
                                        key={index}
                                        className="item-card-content"
                                      >
                                        <div
                                          className="item-card"
                                          onClick={() =>
                                            this.handlePreviewFile(doc, index)
                                          }
                                          style={{ cursor: "pointer" }}
                                        >
                                          {/* Left: icon */}
                                          <div className="left-section">
                                            <img
                                              src={fileTypeIcon}
                                              alt="file icon"
                                              className="doc-icon"
                                            />
                                          </div>
                                          {/* Middle: file name */}
                                          <div
                                            className="middle-section"
                                            title={doc.name || doc.fileName}
                                          >
                                            <div className="doc-title">
                                              {getTruncatedFilename(doc)}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </Panel.Body>
                            )}
                          </Panel>
                        ) : (
                          ""
                        )}
                        <div className="smart-app-section">
                          <div className="title">
                            SMART App
                            <p>Add the app for this product</p>
                          </div>
                          <div className="add-app">
                            <button
                              className={`add-app-btn ${
                                showAddApp ? "secondary" : "primary"
                              }`}
                              onClick={this.toggleApp}
                              type="button"
                              aria-label={
                                showAddApp
                                  ? "Select Existing App"
                                  : "Add New App"
                              }
                            >
                              {showAddApp ? (
                                <React.Fragment>
                                  <i className="icon-arrow-left"></i> Select
                                  Existing App
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                  <i className="icon-plus"></i> Add New App
                                </React.Fragment>
                              )}
                            </button>
                          </div>
                          {!showAddApp ? (
                            <div className="form-group">
                              <label htmlFor="smartAppDropdown">
                                Select existing SMART App
                              </label>
                              <Dropdown
                                id="smartAppDropdown"
                                onChange={this.handleSmartAppChange}
                                filter={true}
                                className="filestring-dropdown filter-dropdown"
                                options={this.state.smartAppList}
                                optionLabel="text"
                                value={this.state.smartApp}
                                onRemote={this.fetchSmartApp}
                                showClear={true}
                                name="smartApp"
                                placeholder="Search or select an app..."
                                ref={(ref) => {
                                  this.smartApp = ref;
                                }}
                                style={{ width: "100%" }}
                                aria-label="SMART App selection dropdown"
                              />
                            </div>
                          ) : (
                            <div className="app-form">
                              <div className="form-group">
                                <label htmlFor="appName">App name</label>
                                <input
                                  type="text"
                                  id="appName"
                                  name="appName"
                                  value={this.state.appName}
                                  onChange={this.handleInputChange}
                                  placeholder="e.g. My Health Tracker"
                                  className="input-field"
                                  maxLength="50"
                                  required
                                  aria-required="true"
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor="androidURL">
                                  App URL (Android)
                                </label>
                                <div className="input-with-hint">
                                  <input
                                    type="url"
                                    id="androidURL"
                                    name="androidURL"
                                    value={this.state.androidURL}
                                    onChange={this.handleInputChange}
                                    placeholder="https://play.google.com/store/apps/..."
                                    className="input-field"
                                    // disabled={!this.state.appName}
                                    maxLength="255"
                                    pattern="https?://.+"
                                    aria-describedby="androidHint"
                                  />
                                </div>
                              </div>
                              <div className="form-group">
                                <label htmlFor="iosURL">App URL (iOS)</label>
                                <div className="input-with-hint">
                                  <input
                                    type="url"
                                    id="iosURL"
                                    name="iosURL"
                                    value={this.state.iosURL}
                                    onChange={this.handleInputChange}
                                    placeholder="https://apps.apple.com/app/..."
                                    className="input-field"
                                    // disabled={!this.state.appName}
                                    maxLength="255"
                                    pattern="https?://.+"
                                    aria-describedby="iosHint"
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                          {this.state.appError && (
                            <div className="error-message" role="alert">
                              <i className="icon-error"></i>{" "}
                              {this.state.appError}
                            </div>
                          )}
                        </div>
                        <div>
                          <Link
                            to={"/home-maintenance"}
                            className="navigate-to-maintenance"
                            disabled={
                              !this.state.itemName ||
                              !this.state.itemCategory ||
                              !this.state.property ||
                              !this.state.locationInHome ||
                              !this.state.typeOfPurchase ||
                              this.state.error ||
                              loading
                            }
                          >
                            + Add Reminder
                          </Link>
                        </div>
                      </Form>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Modal.Body>
          <Modal.Footer className="modal-footer-addDocument">
            {loading && (
              <div className="loading-indicator">Uploading file...</div>
            )}

            <button
              className="save-doc-btn"
              type="submit"
              onClick={this.onSubmit}
              disabled={
                !this.state.itemName ||
                !this.state.itemCategory ||
                !this.state.property ||
                !this.state.locationInHome ||
                !this.state.typeOfPurchase ||
                !this.state.price ||
                this.state.error ||
                loading
              }
            >
              Update Item
            </button>
          </Modal.Footer>
        </Modal>
        {this.renderPreviewModal()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    LotDocuments: state.LotStore.LotDocuments,
  };
};

export default connect(mapStateToProps)(InventoryEditItemModal);



// WEBPACK FOOTER //
// ./src/Lots/Components/inventoryEditItem.js